/* eslint-disable @typescript-eslint/no-explicit-any */
import { NextRequest, NextResponse } from 'next/server';
import NextJs from '@edirect/trace/dist/middlewares/nextjs';

import { utmMiddleware } from './utm.middleware';
import { UTMCookieSignature, UTMParams } from '../types/utm.type';

import { UtmFromUrl } from '@bolttech/essentials';
import { utmParams } from '../constants/utm.constants';
import { getPageDataFromUrl, getPageFromPath } from '../utils/session.util';

const defaultUtmSource = 'Direct';

export async function edgeMiddleware(
  request: NextRequest,
  utmsDefault: any,
  urlMap: any,
): Promise<NextResponse> {
  const url = request.nextUrl;

  const nextResponse = edgeMiddlewareValidation(request);
  if (nextResponse) {
    return nextResponse;
  }

  if (!url.pathname.includes('/desktop') && !url.pathname.includes('/mobile')) {
    const { locale, vertical, viewport } = edgeMiddlewareGetPageDataFromUrl(
      request,
      urlMap,
    );

    url.pathname = `${url.pathname}/${viewport}`.replace(/\/\//g, '/');

    // Set the default UTMS setting up by the instance
    const response = NextResponse.rewrite(url);

    return await utmMiddleware(
      request,
      response,
      utmsDefault,
      vertical,
      locale,
    );
  }

  return NextResponse.next();
}

export function edgeMiddlewareValidation(request: NextRequest) {
  const url = request.nextUrl;
  if (
    url.pathname.includes('/_next/') ||
    url.pathname.includes('/assets/') ||
    url.pathname.includes('/favicon.ico')
  ) {
    return NextResponse.next();
  }

  try {
    new NextJs().body(request as unknown as Request & Record<string, unknown>);
  } catch (error) {
    console.error(`Failed to send data to Open Telemetry: ${error}`);
  }
  if (url.pathname.includes('/api/')) return NextResponse.next();

  return null;
}

export function edgeMiddlewareGetPageDataFromUrl(request: NextRequest, urlMap: any) {
  const url = request.nextUrl;
  const utmParamsFromUrl: UTMParams = <UTMParams>{};
  (utmParams as Array<UTMCookieSignature>).forEach((utmKey) => {
    if (utmKey === 'utm_source' && !url.searchParams.get(utmKey)) {
      const utmsFromCookies = request.cookies.get('utms')?.value;
      const parsedUtms = utmsFromCookies && JSON.parse(utmsFromCookies);
      const { vertical } = getPageFromPath(url.pathname, urlMap);
      const partnerFromCookie = parsedUtms?.[vertical]?.source;
      utmParamsFromUrl[UtmFromUrl[utmKey]] =
        partnerFromCookie || defaultUtmSource;
    } else {
      utmParamsFromUrl[UtmFromUrl[utmKey]] =
        url.searchParams.get(utmKey) || null;
    }
  });

  const utmSource = utmParamsFromUrl.source || defaultUtmSource;
  const { redirectUrl, locale, vertical, viewport } = getPageDataFromUrl(
    request,
    utmSource,
    urlMap,
  );

  return { redirectUrl, locale, vertical, viewport };
}
